<div class="data-action-form">
  <div class="row justify-content-between align-items-center">
    <div class="col-12 col-sm-12 col-md-7 col-lg-6 col-xl-5">
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item" *ngIf="arCustomerDetail">{{ arCustomerDetail.name }}</li>
        </ol>
      </nav>
    </div>
    <div class="col-12 col-sm-12 col-md-5 col-lg-6 col-xl-7">
      <div class="text-left text-md-right">
        <a href="javascript:void(0);" routerLink="/customers" routerLinkActive="active" class="btn btn-dark mb-3 mr-2"
          >Cancel</a
        >
        <button type="submit" class="btn btn-success mb-3" (click)="submitCustomerDetails(arCustomerDetailForm)">
          Save Changes
        </button>
      </div>
    </div>
  </div>
</div>
<form [formGroup]="arCustomerDetailForm">
  <div class="row">
    <div class="col-12 col-sm-12 col-md-12 col-lg-6">
      <div class="card">
        <div class="card-header font-weight-bold">Customer Details</div>
        <div class="card-body">
          <fieldset disabled>
            <input type="hidden" class="form-control" formControlName="id" />
            <div class="row">
              <div class="col-12 col-sm-6 col-md-6 col-lg-6">
                <div class="form-group">
                  <label>Customer Name</label>
                  <input type="text" class="form-control" formControlName="name" />
                </div>
              </div>
              <div class="col-12 col-sm-6 col-md-6 col-lg-6">
                <div class="form-group">
                  <label>Customer ID</label>
                  <input type="text" class="form-control" formControlName="customer_id" />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-sm-6 col-md-6 col-lg-6">
                <div class="form-group">
                  <label>Address</label>
                  <input type="text" class="form-control" formControlName="address" />
                </div>
              </div>
              <div class="col-12 col-sm-6 col-md-6 col-lg-6">
                <div class="form-group">
                  <label>State</label>
                  <input type="text" class="form-control" formControlName="state" />
                </div>
              </div>
            </div>
          </fieldset>
        </div>
      </div>
    </div>
    <div class="col-12 col-sm-12 col-md-12 col-lg-6">
      <div class="card">
        <div class="card-header font-weight-bold">Additional Billing Details</div>
        <div class="card-body">
          <!-- <fieldset *ngIf="billingDetailsArray.length === 1">
            <div class="row">
              <div class="col-12 col-sm-6 col-md-6 col-lg-4">
                <div class="form-group">
                  <label>Contact Name</label>
                  <input type="text" class="form-control" formControlName="contactName" />
                </div>
              </div>
              <div class="col-12 col-sm-6 col-md-6 col-lg-4">
                <div class="form-group">
                  <label>Contact Email</label>
                  <input type="text" class="form-control" formControlName="contactEmail" />
                </div>
              </div>
              <div class="col-12 col-sm-6 col-md-6 col-lg-4">
                <div class="form-group">
                  <label>Contact Phone Number</label>
                  <input type="text" class="form-control" formControlName="phoneNumber" mask="(XXX) XXX-XXXX" />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-sm-6 col-md-6 col-lg-4">
                <div class="form-group">
                  <label>Portal Website/Billing Email</label>
                  <input type="text" class="form-control" formControlName="billingEmail" />
                </div>
              </div>
              <div class="col-12 col-sm-6 col-md-6 col-lg-6">
                <div class="form-group">
                  <label>Billing Notes</label>
                  <textarea class="form-control" rows="1" formControlName="billingNote" placeholder="Billing Notes">
                  </textarea>
                </div>
              </div>
            </div>
          </fieldset> -->

          <!-- Add More Billing Details -->
          <fieldset formArrayName="billingDetailsArray">
            <div
              class="contact-container"
              *ngFor="let contact of billingDetailsArray.controls; let i = index"
              [formGroupName]="i">
              <div class="row">
                <div class="col-12 col-sm-6 col-md-6 col-lg-4">
                  <div class="form-group">
                    <label>Contact Name</label>
                    <input type="text" class="form-control" formControlName="contactName" />
                  </div>
                </div>
                <div class="col-12 col-sm-6 col-md-6 col-lg-4">
                  <div class="form-group">
                    <label>Contact Email</label>
                    <input type="text" class="form-control" formControlName="contactEmail" />
                  </div>
                </div>
                <div class="col-12 col-sm-6 col-md-6 col-lg-4">
                  <div class="form-group">
                    <label>Contact Phone Number</label>
                    <input type="text" class="form-control" formControlName="phoneNumber" mask="(XXX) XXX-XXXX" />
                  </div>
                </div>
              </div>
              <div class="row align-items-end">
                <div class="col-12 col-sm-6 col-md-6 col-lg-4">
                  <div class="form-group">
                    <label>Portal Website/Billing Email</label>
                    <input type="text" class="form-control" formControlName="billingEmail" />
                  </div>
                </div>
                <div class="col-12 col-sm-6 col-md-6 col-lg-6">
                  <div class="form-group">
                    <label>Billing Notes</label>
                    <textarea
                      class="form-control"
                      rows="1"
                      formControlName="billingNote"
                      placeholder="Billing Notes"></textarea>
                  </div>
                </div>
                <div class="col-12 col-sm-2 col-md-4 col-lg-2">
                  <div *ngIf="billingDetailsArray.length > 1" class="form-group">
                    <a href="javascript:;" class="remove" (click)="deleteRow(i)">
                      <i class="far fa-times-circle"></i>
                    </a>
                  </div>
                </div>
              </div>
              <div class="divider"></div>
            </div>
          </fieldset>

          <!-- Adjusted HTML template -->
          <div class="add-fild">
            <a href="javascript:;" class="font-weight-bold text-primary" (click)="addRow()"> + Add Billing Contact </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
